import styles from './styles/PageFilters.module.scss';
import { ReactNode } from 'react';
import cn from 'classnames';

export default function PageFilters({
  children,
  className,
  topBorder = false
}: {
  children: ReactNode;
  className?: string;
  topBorder?: boolean;
}) {
  return <div className={cn(styles.PageFilters, { [styles.TopBorder]: topBorder }, className)}>{children}</div>;
}
